import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SignatureRoutingModule } from './signature-routing.module';
import { CreateSignatureComponent } from './components/create-signature/create-signature.component';
import { ResultComponent } from './components/result/result.component';
import { CertificateComponent } from './components/certificate/certificate.component';
import {
  MAT_DIALOG_DATA,
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatButtonModule,
  MatDialogModule,
  MatDialogRef,
  MatFormFieldModule,
  MatInputModule,
  MatSortModule,
  MatTableModule
} from '@angular/material/';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CertificateDialogComponent } from './components/certificate-dialog/certificate-dialog.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ResultDialogComponent } from './components/result-dialog/result-dialog.component';
import { SignatureSessionService } from './services/signature-session.service';
import { ScwsService } from './services/scws-service.service';
import { StepperComponentActivationService } from './guards/stepper-component-activation-service';
import { SharedModule } from '../shared/shared.module';
import { IdopteCheckerComponent } from './components/idopte-checker/idopte-checker.component';
import { AceEditorModule } from 'ng2-ace-editor';
import { SignatureParametersComponent } from './components/signature-parameters/signature-parameters.component';
import { MatIconModule } from '@angular/material/icon';
import { PinValidatorService } from './services/pin-validator.service';
import { SignatureRedirectionService } from './guards/signature-redirection.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { XsrfInterceptor } from 'src/app/Interceptors/xsrf.interceptor';

@NgModule({
  declarations: [
    ResultComponent,
    ResultDialogComponent,
    IdopteCheckerComponent,
    CertificateComponent,
    CertificateDialogComponent,
    CreateSignatureComponent,
    SignatureParametersComponent,
  ],
  imports: [
    CommonModule,
    SignatureRoutingModule,
    SharedModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDocViewerModule,
    NgxExtendedPdfViewerModule,
    AceEditorModule,
    MatInputModule,
    FormsModule,
    MatFormFieldModule,
    MatDialogModule,
    MatTableModule,
    AceEditorModule,
    MatIconModule,
    MatButtonModule,
    MatSortModule
  ],
  entryComponents: [
    ResultDialogComponent,
    IdopteCheckerComponent,
    CreateSignatureComponent,
    CertificateComponent,
    CertificateDialogComponent,
    ResultComponent,
    SignatureParametersComponent
  ],
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        hasBackdrop: false
      }
    },
    SignatureRedirectionService,
    SignatureSessionService,
    ScwsService,
    StepperComponentActivationService,
    PinValidatorService,
    {
      provide: MAT_DIALOG_DATA,
      useValue: {}
    },
    {
      provide: MatDialogRef,
      useValue: {}
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XsrfInterceptor, multi: true,
    }
  ]

})
export class SignatureModule {
}
